import * as React from 'react';
import * as _ from 'lodash';
import { hashHistory } from 'react-router';
import { PARTS } from './../../schemas/accessRightsModel';
export default function (props, context) {
    function onClick1(AR) {
        AR.e(PARTS.FILTERS_ADD_FILTER) && props.tryAddNewFilterGroup();
    }
    function onClick2(AR) {
        AR.e(PARTS.FILTERS_ASSIGN_FEATURES) && hashHistory.push('/filtersAssignToFeatures');
    }
    function onClick3(AR) {
        AR.e(PARTS.FILTERS_ASSIGN_STONES) && hashHistory.push('/filtersAssignToStones');
    }
    function scopeAR4() {
        var AR = props.AR;
        return React.createElement('div', {}, props.hasGroups ? React.createElement('div', {
            'className': 'app-content-header app-content-header--with-button app-content-header--lined',
            'key': '188'
        }, AR.v(PARTS.FILTERS_EDIT_GROUP) && props.hasGroups ? React.createElement('button', {
            'className': 'ui-button--add ui-button ui-button--green',
            'onClick': onClick1.bind(this, AR),
            'key': '316'
        }, React.createElement('span', { 'className': 'ui-button-icon ui-button-icon--add' }), React.createElement('span', { 'className': 'ui-button-text' }, 'Add Filter Group')) : null, AR.v(PARTS.FILTERS_ASSIGN_FEATURES) && props.hasGroups ? React.createElement('button', {
            'className': 'ui-button--add ui-button ui-button--green',
            'onClick': onClick2.bind(this, AR),
            'key': '669'
        }, React.createElement('span', { 'className': 'ui-button-text' }, 'Assign to Features')) : null, AR.v(PARTS.FILTERS_ASSIGN_STONES) && props.hasGroups ? React.createElement('button', {
            'className': 'ui-button--add ui-button ui-button--green',
            'onClick': onClick3.bind(this, AR),
            'key': '986'
        }, React.createElement('span', { 'className': 'ui-button-text' }, 'Assign to Stones')) : null) : null, !props.hasGroups ? React.createElement('div', {
            'className': 'app-content-header app-content-header--text app-content-header--lined',
            'key': '1303'
        }, '\r\n    Create an initial filter group by setting the following parameters and saving\r\n  ') : null);
    }
    return scopeAR4.apply(this, []);
}